<div class="entity-actions">
  @if (customer?.status !== 'SUSPENDED') {
    <button
      class="action-button action-button-suspend"
      [disabled]="isControlsDisabled | accessControl | async"
      (click)="btnClicked.emit('SUSPEND')"
      title="Suspend Customer"
    >
      <rkt-icon name="suspend"></rkt-icon>
    </button>
  }
  @if (customer?.status === 'SUSPENDED') {
    <button
      class="action-button action-button-unsuspend"
      [disabled]="isControlsDisabled | accessControl | async"
      (click)="btnClicked.emit('UNSUSPEND')"
      title="Unsuspend Customer"
    >
      <rkt-icon name="resume"></rkt-icon>
    </button>
  }
</div>
